import { SupportingContent } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useInviteModalActions } from "shared-ui";

import { COMMON_MESSAGES } from "../common-messages";

export const DocumentUploadSupportingContent = () => {
  const intl = useIntl();
  const { openInviteModal } = useInviteModalActions();
  const openInviteModalHandler = () => {
    openInviteModal();
  };
  return (
    <>
      <SupportingContent
        securityInfo={{
          label: intl.formatMessage({
            id: "funding-application: data security statement",
            defaultMessage: "Your data is securely stored in encrypted databases",
          }),
          link: {
            external: true,
            linkText: intl.formatMessage(COMMON_MESSAGES.viewOurPrivacyNotice),
            url: "https://www.wayflyer.com/privacy-notice",
          },
        }}
        supportingLinks={{
          heading: intl.formatMessage({
            id: "funding-application: unable to upload documents",
            defaultMessage: "Unable to upload documents?",
          }),
          links: [
            {
              linkText: intl.formatMessage({
                id: "funding-application: invite for doc upload",
                defaultMessage: "Invite a team member to upload documents for you.",
              }),
              onClick: openInviteModalHandler,
            },
            {
              external: true,
              url: "https://help-center.wayflyer.com",
              linkText: intl.formatMessage({
                id: "funding-application: learn more about document upload",
                defaultMessage: "Learn more about uploading documents in our Help Center",
              }),
            },
          ],
        }}
      />
    </>
  );
};
